import _ from 'lodash';
import React, { Component, PropTypes } from 'react';

class App extends Component {
  static propTypes = {
    children: PropTypes.element
  }

  static contextTypes = {
    flux: PropTypes.object.isRequired
  }

  static childContextTypes = {
    messages: PropTypes.object.isRequired,
    locales: PropTypes.array.isRequired,
    config: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired
  }

  state = {
    i18n: this.context.flux.getStore('locale').getState(),
    ctxState: this.context.flux.getStore('Ctx').getState()
  }

  getChildContext() {
    const { i18n: { messages, locales }, ctxState: { config, location, page } } = this.state;

    return {
      messages, locales, config, location, page
    };
  }

  componentWillMount() {
    const {
      ctxState: {
        config: {
          appOptions: {
            contentClassification = '',
            pageType = ''
          } = {}
        } = {}
      } } = this.state;
    const { flux } = this.context;

    flux.getStore('locale').listen(this._handleLocaleChange);
    flux.getStore('Helmet').listen(this._handleHelmetChange);
    flux.getStore('Ctx').listen(this._handleCtxChange);
    flux.getActions('ContentClassification').updateAppContentClassification(contentClassification);
    flux.getActions('Advertisement').updateAppTargetingKeyValue('wnpt', pageType);
  }

  componentWillUnmount() {
    const { flux } = this.context;

    flux.getStore('locale').unlisten(this._handleLocaleChange);
    flux.getStore('Helmet').unlisten(this._handleHelmetChange);
    flux.getStore('Ctx').unlisten(this._handleCtxChange);
  }

  _handleLocaleChange = (i18n) => {
    this.setState({
      i18n
    });
  }

  _handleHelmetChange({ titleBase, title, metas }) {
    if (process.env.BROWSER) {
      document.title = (title ? (title + ' - ') : '') + titleBase;

      if (metas) {
        const _replaceMetaTag = (key, value) => {
          return window['$'](`meta[${key}=` + value.replace(/(:|\.|\[|\]|,|=)/g, '\\$1') + ']');
        };

        _.each(metas, (meta) => {
          const { name, isLink, property } = meta;
          let $el;

          if (name) {
            $el = _replaceMetaTag('name', name);
          }

          if (property) {
            $el = _replaceMetaTag('property', property);
          }

          if (!$el || $el.size() === 0) {
            // Add if doesn't exist by the same name
            if (isLink === true) {
              $el = window['$']('<link>');
            } else {
              $el = window['$']('<meta>');
            }
            window['$']('head').append($el);
          }

          _.each(meta, (val, key) => {
            if (key === 'isLink') {
              return;
            }
            $el.attr(key, val);
          });
        });
      }
    }
  }

  _handleCtxChange = (ctxState) => {
    this.setState({
      ctxState
    });
  }

  render() {
    const { children } = this.props;

    return (
      <div className="App">
        {children}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./app/components/core/App.js